<div class="content-container content-with-sidebar h-screen">
    <header class="content-header">
        <div class="content-header-outer-wrap">
            <div class="content-header-inner-wrap">
                <div class="content-header-left-content">
                    <div class="flex-col">
                        <h1 class="content-header-title">Import size groups</h1>
                        <div class="content-header-subtitle">Allows Import of size groups from excel</div>
                    </div>
                </div>
                <div class="content-header-right-content">
                </div>
            </div>
        </div>
    </header>

    <main class="@container/workarea content-area content-area-padding">
        <div id="tab1" class="tabs-content tabs-content-active">
            <div class="flex flex-col gap-4">
                <details class="accordion" open>
                    <summary class="accordion-header">
                        <span class="accordion-title">Import</span>
                    </summary>
                    <div class="accordion-content">
                        @if (importdata == null)
                        {
                            <div class="space-y-4">                                
                                <div class="form-row">
                                    <div class="form-row-info">
                                        <h3 class="form-row-info-title">
                                            Select size group
                                        </h3>
                                        <div class="form-row-info-description">
                                            Select the size group for these item numbers
                                        </div>
                                    </div>
                                    <div class="form-row-field w-96">
                                        <ng-select
                                            [items]="sizeGroups"
                                            bindValue="Uid"
                                            bindLabel="Name"
                                            [(ngModel)]="selectedSizeGroup"
                                            [clearable]="true"
                                            [searchable]="true"
                                            style="overflow: visible;"
                                            placeholder="Choose an option"
                                        ></ng-select>
                                    </div>
                                </div>
                                <hr class="border-gray-100 my-5">
                                <div class="form-row">
                                    <div class="form-row-info">
                                        <h3 class="form-row-info-title">
                                            Select file
                                        </h3>
                                        <div class="form-row-info-description">
                                            Import file with size data
                                        </div>
                                    </div>
                                    <div class="form-row-field w-96">
                                        <label class="border-dashed border-2 border-gray-200 p-2 text-base w-full block rounded cursor-pointer mb-2" for="customFile">
                                            
                                            {{ selectedFile !== null ? selectedFile.name : 'Choose file...' }}
                                        </label>
                                        <input type="file" id="customFile" name="customFile" (change)="onFileChange($event)" class="hidden" />
                                    </div>
                                </div>
                            </div>
                        }
                        <br />
                        @if (importdata != null)
                        {
                            <div class="card">
                                <div class="card-header">
                                    <h3 class="card-title">Validate Data</h3>
                                </div>
                                <div class="card-body">
                                    <div class="space-y-4">
                                        <div>
                                            <label class="block text-sm mb-1">
                                                Data
                                                <small>
                                                    Validate the data in the file, before committing the import
                                                </small>
                                            </label>
                                        </div>
                                        <div>
                                            @if (importdata.InvalidHeaders.length > 0)
                                            {
                                            <div style="padding:5px">
                                                <div>Følgende dimensioner findes ikke i forvejen. Ret til eksisterende, eller opret værdierne i "Dimensioner":&nbsp; </div>
                                                <div style="border: 2px red dashed">
                                                    {{importdata.InvalidHeaders.join(', ')}}
                                                </div>
                                            </div>
                                            }
                                            <table class="table">
                                                <thead>
                                                    @for(row of importdata.TransposedTableData; track $index)
                                                    {
                                                        @if ($index < importdata.NumberOfHeaderRows)
                                                        {
                                                        <tr>
                                                            @for(col of row; track $index)
                                                            {
                                                                <th class="table-header">{{col}}</th>
                                                            }
                                                        </tr>
                                                        }
                                                    }
                                                </thead>
                                                <tbody>
                                                    @for (row of importdata.TransposedTableData; track $index)
                                                    {
                                                        @if ($index >= importdata.NumberOfHeaderRows)
                                                        {
                                                        <tr>
                                                            @for(col of row; track $index)
                                                            {
                                                                <td class="table-cell">{{col}}</td>
                                                            }
                                                        </tr>
                                                        }
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </details>
            </div>
        </div>
    </main>

    <footer class="content-footer">
        <div class="content-footer-inner-wrap">
            <div class="content-footer-left-content">
                <span class="text-sm text-gray-600"></span>
            </div>
            <div class="content-footer-right-content">
                @if (importdata == null)
                {
                    <div class="flex gap-2">
                        <button class="btn btn-default" (click)="reset()">Discard changes</button>
                        <button class="btn btn-primary" (click)="validate()" [disabled]="!isValid">
                            Upload
                            @if (working)
                            {
                            <div class="ml-2 w-4 h-4 border-2 border-white-500 border-t-transparent rounded-full animate-spin"></div>
                            }
                        </button>
                    </div>
                }

                @if (importdata != null)
                {
                    <div class="flex gap-2">
                        <button class="btn btn-default" (click)="reset()">Discard changes</button>
                        @if (importdata.InvalidHeaders.length == 0)
                        {
                            <button class="btn btn-primary" (click)="commit()" [disabled]="working">
                                Import size guide
                                @if (working)
                                {
                                <div class="ml-2 w-4 h-4 border-2 border-white-500 border-t-transparent rounded-full animate-spin"></div>
                                }
                            </button>
                        }
                        @if (importdata.InvalidHeaders.length > 0)
                        {
                            <button class="btn btn-danger">Cannot import - invalid dimensions</button>
                        }
                    </div>
                }
            </div>
        </div>
    </footer>
</div>
